import React from 'react';
import InfoTooltip from './InfoTooltip';
import { ORANGE_BOOK_DATA_FILES_URL } from '../utils/applTypeLabels';

export interface ApplTypeHeaderTooltipProps {
  /** Forwarded to InfoTooltip — override for a call site nested above InfoTooltip's own default. */
  zIndex?: number;
}

/**
 * Field-level tooltip for the "Application Type" label — explains what the
 * field means and links back to the source. Mirrors
 * TeCodeHeaderTooltip.tsx's pattern (2026-09-23 follow-up feedback: a bare
 * "N"/"A" carries no explanation anywhere `appl_type` is shown standalone).
 */
const ApplTypeHeaderTooltip: React.FC<ApplTypeHeaderTooltipProps> = ({
  zIndex,
}) => (
  <InfoTooltip
    ariaLabel="About Application Type"
    zIndex={zIndex}
    interactive
    text={
      <span>
        N = New Drug Application (NDA), A = Abbreviated New Drug Application
        (ANDA)
        <br />
        Source:{' '}
        <a
          href={ORANGE_BOOK_DATA_FILES_URL}
          target="_blank"
          rel="noopener"
          style={{ color: 'inherit', textDecoration: 'underline' }}>
          Orange Book Data Files
        </a>
      </span>
    }
  />
);

export default ApplTypeHeaderTooltip;
